<div class="earn-points-container">
  <ng-container *ngIf="earnPoints$ | async as earnPoints">
    <ng-container *ngFor="let earnPointSection of earnPoints">
      <h2 class="earn-sub-heading">
        {{ earnPointSection.DisplayText }}
      </h2>
      <div class="earn-points-content">
        <ng-container *ngIf="!!earnPointSection.Description">
          <div class="mb-3" [innerHTML]="earnPointSection.Description"></div>
        </ng-container>
        <div class="row">
          <ng-container *ngFor="let earnPointsCard of earnPointSection.SectionItems">
            <div class="content col-lg-{{ lgWidth }} col-12">
              <fgbcl-earn-points-card [earnPointsCard]="earnPointsCard"></fgbcl-earn-points-card>
            </div>
          </ng-container>
        </div>

        @if (earnPointSection.FooterText) {
          <div class="earn-points-footer-text">{{ earnPointSection.FooterText }}</div>
        }
      </div>
    </ng-container>
  </ng-container>
</div>
